const AllProducts = [
    // Hermes
    {
        id: 1000,
        priority: 1,
        title: 'Hermes',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44],
        price: 445,
        originalPrice: 750,
        currency: 'AED',
        type: 'shoes',
        brand: 'hermes',
        model: 'Hermes',
        colors: 18,
        rating: 4.8,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "The Hermes is a classic sneaker that combines style and comfort. With its iconic design and premium materials, it's perfect for any occasion.",
        image: 'https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198649/1_ds5yum.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198649/1_ds5yum.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198649/3_m7ao36.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198649/2_i6b4zp.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198655/6_ouozca.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198651/5_x65mdr.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198650/4_cqqnk5.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/v1751198651/7_zb2hq6.jpg",

        ],
        reviews: [
            {
                "name": "Fatima A.",
                "location": "Dubai, UAE",
                "rating": 5,
                "review": "Love it! They are very comfortable!. Wore them all day at Dubai Mall with no issues. 💯"
            },
            {
                "name": "Mohammed R.",
                "location": "Abu Dhabi, UAE",
                "rating": 4.8,
                "review": "Very good quality shoes, and delivery was fast. Wore them to work and got compliments. Will order again."
            },
            {
                "name": "Sana K.",
                "location": "Sharjah, UAE",
                "rating": 5,
                "review": "Mashallah, very elegant design and feels premium. Perfect for daily wear or going out."
            },
            {
                "name": "Ahmed B.",
                "location": "Al Ain, UAE",
                "rating": 4.8,
                "review": "I liked the comfort and price. Design is modern. Only wish there were more colour options."
            },
            {
                "name": "Ravi D.",
                "location": "Dubai Marina, UAE",
                "rating": 5,
                "review": "Honestly surprised by the quality. I’ve tried many brands but Luxay is now my go-to."
            },
            {
                "name": "Noor Z.",
                "location": "Mirdif, Dubai",
                "rating": 5,
                "review": "Stylish and breathable. Perfect for UAE weather. Will buy another pair soon Inshallah."
            },
            {
                "name": "Omar T.",
                "location": "Jumeirah, Dubai",
                "rating": 4.8,
                "review": "Nice for casual and gym wear. Feels light on the feet. Good value for money."
            },
            {
                "name": "Liam S.",
                "location": "Dubai Silicon Oasis",
                "rating": 5,
                "review": "As a Brit living in Dubai, these are my new favourite trainers. Great job Luxay team!"
            },
            {
                "name": "Aisha M.",
                "location": "Khalifa City, Abu Dhabi",
                "rating": 5,
                "review": "Very comfy and trendy. Loved the packaging too, felt like opening a gift 🎁"
            },
            {
                "name": "Rajiv K.",
                "location": "Deira, Dubai",
                "rating": 4.8,
                "review": "Great for walking and office wear. Shoes fit true to size. Impressed."
            },
            {
                "name": "Noura H.",
                "location": "Ajman, UAE",
                "rating": 5,
                "review": "Bought one for my brother and now the whole family wants one 😂"
            },
            {
                "name": "Youssef E.",
                "location": "Dubai Hills",
                "rating": 4.8,
                "review": "Nice design and feels durable. Perfect for everyday use. Delivery took 2 days, not bad."
            },
        ]
    },
    // 1 Nike Product
    {
        id: 1001,
        priority: 17,
        title: 'Nike Air Force Premium',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
        price: 155,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Air Force',
        colors: 18,
        rating: 4.8,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "The Nike Air Force 1 is a classic sneaker that combines style and comfort. With its iconic design and premium materials, it's perfect for any occasion.",
        image: '/images/IMG_2516.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730423/IMG_2508_nc0stg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730146/IMG_2514_micc1b.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730427/IMG_2503_rynggj.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730427/IMG_2502_ckd6b8.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730426/IMG_2506_ziftoo.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730426/IMG_2504_z6h2v8.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730425/IMG_2510_cxbwdq.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730424/IMG_2505_lnn6eh.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730423/IMG_2509_zdej9c.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730423/IMG_2519_to9frz.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730150/IMG_2511_lhk2kz.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730150/IMG_2507_i6egxr.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730148/IMG_2518_eoakni.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730149/IMG_2513_wjerip.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730149/IMG_2516_anspb9.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730148/IMG_2512_leeexo.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746730147/IMG_2517_fwohhr.jpg",
        ],
        reviews: [
            {
                "name": "Fatima A.",
                "location": "Dubai, UAE",
                "rating": 5,
                "review": "Love it! They are very comfortable!. Wore them all day at Dubai Mall with no issues. 💯"
            },
            {
                "name": "Mohammed R.",
                "location": "Abu Dhabi, UAE",
                "rating": 4.8,
                "review": "Very good quality shoes, and delivery was fast. Wore them to work and got compliments. Will order again."
            },
            {
                "name": "Sana K.",
                "location": "Sharjah, UAE",
                "rating": 5,
                "review": "Mashallah, very elegant design and feels premium. Perfect for daily wear or going out."
            },
            {
                "name": "Ahmed B.",
                "location": "Al Ain, UAE",
                "rating": 4.8,
                "review": "I liked the comfort and price. Design is modern. Only wish there were more colour options."
            },
            {
                "name": "Ravi D.",
                "location": "Dubai Marina, UAE",
                "rating": 5,
                "review": "Honestly surprised by the quality. I’ve tried many brands but Luxay is now my go-to."
            },
            {
                "name": "Noor Z.",
                "location": "Mirdif, Dubai",
                "rating": 5,
                "review": "Stylish and breathable. Perfect for UAE weather. Will buy another pair soon Inshallah."
            },
            {
                "name": "Omar T.",
                "location": "Jumeirah, Dubai",
                "rating": 4.8,
                "review": "Nice for casual and gym wear. Feels light on the feet. Good value for money."
            },
            {
                "name": "Liam S.",
                "location": "Dubai Silicon Oasis",
                "rating": 5,
                "review": "As a Brit living in Dubai, these are my new favourite trainers. Great job Luxay team!"
            },
            {
                "name": "Aisha M.",
                "location": "Khalifa City, Abu Dhabi",
                "rating": 5,
                "review": "Very comfy and trendy. Loved the packaging too, felt like opening a gift 🎁"
            },
            {
                "name": "Rajiv K.",
                "location": "Deira, Dubai",
                "rating": 4.8,
                "review": "Great for walking and office wear. Shoes fit true to size. Impressed."
            },
            {
                "name": "Noura H.",
                "location": "Ajman, UAE",
                "rating": 5,
                "review": "Bought one for my brother and now the whole family wants one 😂"
            },
            {
                "name": "Youssef E.",
                "location": "Dubai Hills",
                "rating": 4.8,
                "review": "Nice design and feels durable. Perfect for everyday use. Delivery took 2 days, not bad."
            },
        ]
    },
    {
        id: 1002,
        title: 'Nike Air Max',
        size: [40, 41, 42, 43, 44, 45],
        price: 195,
        originalPrice: 270,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Air Max',
        colors: 6,
        rating: 4.8,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750674/IMG_2459_h9emw4.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750678/IMG_2458_qseipk.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750677/IMG_2461_zbpkhn.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750677/IMG_2457_wztmil.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750675/IMG_2460_tbxa7g.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750673/IMG_2462_r47vzz.jpg",
        ],
        reviews: [
            {
                "name": "Zainab L.",
                "location": "Ras Al Khaimah",
                "rating": 5,
                "review": "Loved the minimalistic design. So light and easy to clean!"
            },
            {
                "name": "Karan M.",
                "location": "Business Bay, Dubai",
                "rating": 5,
                "review": "Top-notch. Looks designer but way more affordable. I’m impressed."
            },
            {
                "name": "Layla F.",
                "location": "Fujairah, UAE",
                "rating": 5,
                "review": "Bought for my husband and he wears them every day now. Highly recommend!"
            },
            {
                "name": "Bilal A.",
                "location": "Al Barsha, Dubai",
                "rating": 4.8,
                "review": "Stylish, solid grip, and breathable even during hot days. Could improve laces a bit."
            },
            {
                "name": "Ibrahim S.",
                "location": "Abu Dhabi Corniche",
                "rating": 5,
                "review": "Perfect balance of style and comfort. I wear them to mosque and to outings."
            },
            {
                "name": "Jenny C.",
                "location": "Dubai International City",
                "rating": 5,
                "review": "Great buy! As a nurse, I need comfy shoes. These are life savers for long shifts."
            },
            {
                "name": "Mariam J.",
                "location": "Umm Al Quwain",
                "rating": 4.8,
                "review": "Very good support for my feet. Looks even better in person. Shukran!"
            },
            {
                "name": "Ali H.",
                "location": "Dubai Sports City",
                "rating": 5,
                "review": "My friends asked where I got them from. Luxay, you’ve got a new loyal customer!"
            }
        ]

    },
    {
        id: 1003,
        title: 'Nike P-6000',
        size: [40, 41, 42, 43, 44, 45],
        price: 170,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'P-6000',
        colors: 4,
        rating: 4.8,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747399957/IMG_2654_enib3z.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747399958/IMG_2656_mhgtaz.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747399957/IMG_2655_idgzp5.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747399958/IMG_2653_pkmzjs.jpg",
        ],
        reviews: [
            {
                name: "Fatima A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Absolutely love the Nike P-6000! Super stylish and comfy. Wore them at Dubai Mall for hours."
            },
            {
                name: "Mohammed R.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Very good quality shoes, and delivery was fast. Wore them to work and got compliments. Will order again."
            },
            {
                name: "Yousef K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "The P-6000 is a great everyday sneaker. Looks retro and feels light on the feet."
            },
            {
                name: "Layla M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Wore my new Nike P-6000s to Global Village—so comfy the entire evening!"
            },
            {
                name: "Ali D.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Perfect for casual wear. Nike never disappoints with the comfort and build."
            },
            {
                name: "Sara H.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "Good cushioning and fit, though I’d recommend sizing half up for wider feet."
            },
            {
                name: "Omar B.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "Great choice for walks around Marina Walk. Stylish and breathable!"
            },
            {
                name: "Noura S.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Love the vintage vibes of the P-6000. Got so many compliments."
            },
            {
                name: "Hassan Z.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Decent support and nice design. A little snug at first, but broke in fast."
            },
            {
                name: "Amina K.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Super lightweight and breathable. Ideal for the UAE heat."
            },
            {
                name: "Rami F.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Fast delivery from Luxay. These Nike P-6000s are my go-to sneakers now."
            },
            {
                name: "Lina W.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.9,
                review: "Nice silhouette and very comfy. Feels premium."
            },
            {
                name: "Tariq N.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Best Nike model I’ve worn in a while. Ideal for everyday errands."
            },
            {
                name: "Huda A.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "The white colorway looks so clean. Fits every outfit."
            },
            {
                name: "Zayd J.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Loved the look and fit. Feels like a mix of classic and modern."
            },
            {
                name: "Salma O.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Comfortable for long wear. Used it while shopping in City Centre."
            },
            {
                name: "Majid A.",
                location: "Fujairah, UAE",
                rating: 4.8,
                review: "The Nike P-6000 is solid. Breathable upper is a plus in UAE summers."
            },
            {
                name: "Rana F.",
                location: "Dubai, UAE",
                rating: 5,
                review: "I’m in love! Got the silver and white combo—very Y2K vibes."
            },
            {
                name: "Bilal H.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Great grip and easy to clean. Took them on a weekend road trip to RAK."
            },
            {
                name: "Dana L.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Feels like walking on air. Used them for Expo and had zero complaints."
            },
            {
                name: "Ahmed M.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Wasn't sure at first, but once I wore them, I didn’t want to take them off."
            },
            {
                name: "Maya T.",
                location: "Dubai Hills, UAE",
                rating: 4.8,
                review: "Perfect balance between comfort and fashion. Great for university wear."
            },
            {
                name: "Khalid R.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "The mesh upper is breathable. Ideal for everyday walking in the city."
            },
            {
                name: "Yara E.",
                location: "Al Ain, UAE",
                rating: 5,
                review: "The design is on point. Nike P-6000 definitely stands out from other sneakers."
            },
            {
                name: "Zainab N.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Good support for walking and even light workouts. Love the neutral tones."
            },
            {
                name: "Farid K.",
                location: "Dubai, UAE",
                rating: 5,
                review: "P-6000 from Nike is one of the best retro-style shoes I’ve bought. Shukran Luxay!"
            }
        ]

    },
    {
        id: 1004,
        title: 'Nike Super SB Dunk',
        priority: 1,
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        price: 205,
        originalPrice: 275,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Super SB Dunk',
        colors: 10,
        rating: 4.9,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314357/IMG_2611_vjnzsb.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314350/IMG_2612_qjdidp.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314354/IMG_2614_rskqbl.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314347/IMG_2610_bmmu87.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314334/IMG_2615_hpc0m2.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314329/IMG_2608_vzspzk.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314331/IMG_2613_lmhutu.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314336/IMG_2606_toy5ip.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314340/IMG_2607_oavjh4.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314343/IMG_2609_hcuxio.png",
        ],
        reviews: [
            {
                name: "Ahmed S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Nike Super SB Dunk is a statement piece. Super comfy and the colorway is 🔥."
            },
            {
                name: "Layla H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Love the street style vibes. Got so many compliments at The Beach JBR."
            },
            {
                name: "Omar Z.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Really cool design. Took a day to break in but now they’re my fav sneakers."
            },
            {
                name: "Nour K.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "Obsessed with the color combo on the SB Dunks! Matches my entire streetwear look."
            },
            {
                name: "Saeed M.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "They feel premium and the fit is just right. Easy to pair with jeans or cargos."
            },
            {
                name: "Zainab L.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "These are pure heat! Nike really nailed the details on this SB Dunk drop."
            },
            {
                name: "Hamad A.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "The Super SB Dunks are a bit stiff at first, but worth the hype. Love them now."
            },
            {
                name: "Mariam T.",
                location: "Dubai Hills, UAE",
                rating: 5,
                review: "Comfortable, bold, and unique. Got them from Luxay and delivery was fast!"
            },
            {
                name: "Rami F.",
                location: "Fujairah, UAE",
                rating: 4.8,
                review: "I wore these to Dubai Design District—everyone asked where I got them. 🔥"
            },
            {
                name: "Huda A.",
                location: "Al Ain, UAE",
                rating: 4.8,
                review: "Loved how different they look. A proper head-turner."
            },
            {
                name: "Tariq Y.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Nike SB never misses. This Super Dunk version is the best in years."
            },
            {
                name: "Salma M.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Nice grip and fit. Good for casual wear or even skating if you’re into that."
            },
            {
                name: "Bilal K.",
                location: "Dubai, UAE",
                rating: 5,
                review: "They go well with everything I wear. Great drop by Nike."
            },
            {
                name: "Amani R.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Such a clean design. Love that it adds a bold touch to every outfit."
            },
            {
                name: "Yousef N.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 5,
                review: "Wore them to a sneaker event in City Walk. Got tons of praise."
            },
            {
                name: "Noor W.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.9,
                review: "Very stylish, but wish the tongue padding was a bit less thick."
            },
            {
                name: "Khalid D.",
                location: "Dubai, UAE",
                rating: 5,
                review: "My favorite SB Dunk so far. The Super version is next level 🔥."
            },
            {
                name: "Reem S.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Amazing finish and colors. Can’t stop wearing them!"
            }
        ]
    },
    {
        id: 1006,
        title: 'Nike M2k Tekno',
        size: [40, 41, 42, 43, 44, 45],
        price: 160,
        originalPrice: 220,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'm2k',
        colors: 6,
        rating: 4.9,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316256/IMG_2636_zy1hj9.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316251/IMG_2637_iwxlcg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316155/IMG_2635_su23r9.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316260/IMG_2632_zruvrv.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316118/IMG_2634_doec5z.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316116/IMG_2633_hxnqzo.jpg",
        ],
        reviews: [
            {
                name: "Khalifa M.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "For a first copy, the Nike M2K Tekno looks almost identical to the original. Really impressed!"
            },
            {
                name: "Ayesha N.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Great value for money. Feels sturdy and stylish, nobody could tell it’s not original."
            },
            {
                name: "Zayed R.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Wore these to Mall of Emirates and they held up so well. First copy but top quality."
            },
            {
                name: "Fatima J.",
                location: "Ajman, UAE",
                rating: 5,
                review: "Very trendy and surprisingly comfortable. Love the chunky vibe of the M2K Tekno!"
            },
            {
                name: "Salman D.",
                location: "Dubai Hills, UAE",
                rating: 4.9,
                review: "The finish and weight feel like the original. For this price, it's a steal."
            },
            {
                name: "Maryam F.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Perfect dupe! Even the stitching is clean. Got mine from Luxay, arrived in 2 days."
            },
            {
                name: "Hassan L.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "First copy but no one would notice unless you told them. Looks fire with joggers!"
            },
            {
                name: "Rania K.",
                location: "Dubai Marina, UAE",
                rating: 4.8,
                review: "Love the retro vibes. Looks so cool with oversized jeans and a hoodie."
            },
            {
                name: "Tariq S.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Fit is a little snug at first but broke in nicely. Super clean design."
            },
            {
                name: "Hiba Y.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Feels like original Nikes honestly. I’ve worn them a lot and they’re still perfect."
            },
            {
                name: "Yousra A.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Definitely worth it. The look is spot on and nobody knows it's a first copy."
            },
            {
                name: "Mohannad E.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.9,
                review: "Good for casual wear and gym. I love the build for a replica."
            },
            {
                name: "Laila B.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Looks very premium. Only I know it’s not retail. Super satisfied."
            },
            {
                name: "Zain M.",
                location: "Fujairah, UAE",
                rating: 5,
                review: "Looks fresh out of a Nike store. Easily my favorite first copy purchase so far."
            },
            {
                name: "Amira H.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.9,
                review: "Quality is better than expected. Got compliments from coworkers too."
            }
        ]
    },
    {
        id: 1007,
        priority: 3,
        title: 'Nike TN Air Max Plus',
        size: [40, 41, 42, 43, 44, 45],
        price: 240,
        originalPrice: 310,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Air Max',
        colors: 14,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316945/rn-image_picker_lib_temp_4bd41cf1-01bf-4d27-8aeb-997915eb20f9_e4otkb.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316942/IMG_2652_laipdd.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316937/IMG_2650_ilyjyy.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316933/IMG_2649_wba1mh.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316928/IMG_2648_kfvdho.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316925/IMG_2645_gzwq8k.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316921/IMG_2647_kb8zbw.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316914/IMG_2642_ry0qka.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316880/IMG_2640_tqxpnl.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316840/IMG_2641_ccfajf.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316837/IMG_2643_ft4xxh.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316832/IMG_2646_djhgjf.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316828/IMG_2644_ldmiui.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747316823/IMG_2639_ordvuc.jpg",
        ],
        reviews: [
            {
                name: "Omar K.",
                location: "Dubai, UAE",
                rating: 5,
                review: "These TN Air Max Plus are 🔥🔥🔥. Super comfy and they stand out big time. Wore them to City Walk and got stares!"
            },
            {
                name: "Fatima H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Amazing detailing. I love the design and the cushion support is perfect for all-day wear."
            },
            {
                name: "Khaled B.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "They look just like the original pair my cousin got from UK. Quality is really on point."
            },
            {
                name: "Rashid M.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "The gradient color effect on these is insane. Got them from Luxay and delivery was smooth."
            },
            {
                name: "Noor A.",
                location: "Ajman, UAE",
                rating: 4.9,
                review: "Love the retro TN style. Feels a bit tight at first but broke in nicely after 2 days."
            },
            {
                name: "Yasir S.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.8,
                review: "I wear these to work and gym both. Very versatile and surprisingly durable."
            },
            {
                name: "Lina K.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Stylish and lightweight. Wore them on Yas Island and walked around for hours with no pain."
            },
            {
                name: "Imran F.",
                location: "Ras Al Khaimah, UAE",
                rating: 5,
                review: "Top tier quality. These TNs look sick with joggers or shorts. Definitely getting another colorway soon."
            },
            {
                name: "Sara D.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "I bought the black and yellow pair. They pop so well! My brother thought they were from the Nike store."
            },
            {
                name: "Walid J.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Super responsive sole and really comfortable. I’ve worn many Nike models but TNs are special."
            },
            {
                name: "Maha L.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "Very bold look! Wasn’t sure if I could pull it off but got loads of compliments at uni."
            },
            {
                name: "Ziyad N.",
                location: "Dubai Hills, UAE",
                rating: 4.8,
                review: "Clean, unique silhouette. They really stand out. Not cheap-looking at all."
            },
            {
                name: "Reem A.",
                location: "Fujairah, UAE",
                rating: 5,
                review: "The color, the design, everything is 10/10. Feels premium and totally worth the price!"
            }
        ]
    },
    {
        id: 1008,
        priority: 18,
        title: 'Nike Air Force 1',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        price: 155,
        originalPrice: 220,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Air Force 1',
        colors: 4,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422539/a96d54f6-4192-4e83-b589-bd88deb95d26.jpg_pnfoog.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422278/IMG_2755_swcued.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422278/IMG_2759_skhzpd.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422277/IMG_2757_zuwhuc.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422276/IMG_2756_vpinvi.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422276/IMG_2758_jhwqdl.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422274/IMG_2754_kyaxzf.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747422141/IMG_2752_nfmjye.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747421867/IMG_2753_alim2a.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747421813/IMG_2751_efxpar.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402071/IMG_2700_jdjjkv.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402075/IMG_2698_kws8vi.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402075/IMG_2701_mo5t0a.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402070/IMG_2697_erhkjs.png",
        ],
        reviews: [
            {
                name: "Mohammed R.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Classic and clean! These Air Force 1s go with everything. My favorite everyday pair."
            },
            {
                name: "Fatima A.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Got the white-on-white AF1s. Super fresh look and very comfortable even after hours of walking."
            },
            {
                name: "Yousef M.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Wore them to Dubai Mall and at least 3 people asked where I got them. Timeless design!"
            },
            {
                name: "Ayesha N.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "A bit stiff on the first wear but broke in quickly. Looks amazing with wide pants."
            },
            {
                name: "Zayd H.",
                location: "Dubai Marina, UAE",
                rating: 4.8,
                review: "First copy but you can't even tell. Got so many compliments, even from sneakerheads."
            },
            {
                name: "Leena S.",
                location: "Ajman, UAE",
                rating: 5,
                review: "Super comfy and goes with abayas and casual outfits. I’m in love 😍"
            },
            {
                name: "Hamza T.",
                location: "Dubai Hills, UAE",
                rating: 4.8,
                review: "Bought them from Luxay. Excellent quality, clean stitching, and fast delivery."
            },
            {
                name: "Rania M.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "A must-have pair. The all-black version looks sleek and lowkey. Very versatile."
            },
            {
                name: "Tariq K.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "These AF1s are built solid. I use them daily and still look fresh after weeks."
            },
            {
                name: "Nour H.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.9,
                review: "Great value for money. Looks and feels like original Nike. Would recommend."
            },
            {
                name: "Khalid S.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.8,
                review: "Always wanted a pair of Air Force 1s. These didn’t disappoint. 🔥"
            },
        ]
    },
    {
        id: 100864651,
        priority: 6,
        title: 'Nike Air Force 1 Low "Coffee"',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        price: 215,
        originalPrice: 275,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Air Force 1',
        colors: 9,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423504/Gia%CC%80y-AF1-Premium-Coffee-1_k7ebhk.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423504/IMG_2666_yerbm5.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423505/IMG_2668_qzjndm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423504/IMG_2667_lfa6ms.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423504/IMG_2669_fqh9ri.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423503/IMG_2665_nzzn5u.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423503/IMG_2664_rdwc37.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423503/IMG_2662_epdaui.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423503/IMG_2663_vdtuzm.jpg",
        ],
        reviews: [
            {
                name: "Rania M.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "A must-have pair. The all-black version looks sleek and lowkey. Very versatile."
            },
            {
                name: "Tariq K.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "These AF1s are built solid. I use them daily and still look fresh after weeks."
            },
            {
                name: "Nour H.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.9,
                review: "Great value for money. Looks and feels like original Nike. Would recommend."
            },
            {
                name: "Khalid S.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.8,
                review: "Always wanted a pair of Air Force 1s. These didn’t disappoint. 🔥"
            },
            {
                name: "Mohammed R.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Classic and clean! These Air Force 1s go with everything. My favorite everyday pair."
            },
            {
                name: "Ayesha N.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "A bit stiff on the first wear but broke in quickly. Looks amazing with wide pants."
            },
            {
                name: "Fatima A.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Got the white-on-white AF1s. Super fresh look and very comfortable even after hours of walking."
            },
            {
                name: "Yousef M.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Wore them to Dubai Mall and at least 3 people asked where I got them. Timeless design!"
            },
            {
                name: "Zayd H.",
                location: "Dubai Marina, UAE",
                rating: 4.8,
                review: "First copy but you can't even tell. Got so many compliments, even from sneakerheads."
            },
            {
                name: "Hamza T.",
                location: "Dubai Hills, UAE",
                rating: 4.8,
                review: "Bought them from Luxay. Excellent quality, clean stitching, and fast delivery."
            },
            {
                name: "Leena S.",
                location: "Ajman, UAE",
                rating: 5,
                review: "Super comfy and goes with abayas and casual outfits. I’m in love 😍"
            },
        ]
    },
    {
        id: 10090,
        title: 'Nike Air Max 90',
        size: [38, 49, 40, 41, 42, 43, 44, 45],
        price: 190,
        originalPrice: 260,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Air Max 90',
        colors: 8,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419500/IMG_2593_kclxfq.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419512/IMG_2594_pwjrym.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419507/IMG_2588_w4sxhg.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419504/IMG_2587_gbedba.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419503/IMG_2592_y1w8rw.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419498/IMG_2595_ostdua.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419496/IMG_2591_h3jgrx.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419447/IMG_2590_vfje0a.jpg",
        ],
        reviews: [
            {
                name: "Omar L.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Air Max 90 is a classic. Super comfy for long mall days, and the color pop is 🔥."
            },
            {
                name: "Fatima R.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Love the vintage vibe. I got the white and pink combo—goes so well with everything!"
            },
            {
                name: "Hassan M.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Great fit, solid build. Looks almost exactly like the original, even though it’s a first copy."
            },
            {
                name: "Layla N.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "Wore them to City Walk and walked for hours. No pain, pure style!"
            },
            {
                name: "Tariq Z.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Feels premium. The Air Max cushioning really makes a difference on long days."
            },
            {
                name: "Aisha B.",
                location: "Al Ain, UAE",
                rating: 5,
                review: "Honestly couldn’t tell it wasn’t original. Got compliments from sneaker collectors."
            },
            {
                name: "Mohammed K.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Really durable, used them for 2 weeks straight and still look box fresh."
            },
            {
                name: "Noor J.",
                location: "Dubai, UAE",
                rating: 5,
                review: "I love the color blocking on the Air Max 90. Such a vibe with jeans and joggers."
            },
            {
                name: "Zain A.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.8,
                review: "Comfortable and stylish—exactly what I needed for my everyday errands."
            },
            {
                name: "Maya S.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.9,
                review: "A bit snug at first but broke in after 2 wears. Loving the design!"
            },
            {
                name: "Hamdan E.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Air Max 90s are always a statement. Got the grey and red ones—so clean."
            },
            {
                name: "Lina K.",
                location: "Dubai Creek, UAE",
                rating: 4.8,
                review: "Perfect for casual days. Matches with my abaya and gives it an urban twist."
            },
            {
                name: "Saeed R.",
                location: "Dubai Hills, UAE",
                rating: 4.9,
                review: "Delivery was fast and packaging was clean. Will definitely buy again from Luxay."
            },
            {
                name: "Huda A.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "These shoes give both style and comfort. Wore them during a long event day."
            },
            {
                name: "Zoya H.",
                location: "Dubai Festival City, UAE",
                rating: 4.8,
                review: "Color, fit, feel – all 10/10. Can’t wait to grab another pair soon."
            },
            {
                name: "Khalifa M.",
                location: "Ajman, UAE",
                rating: 4.9,
                review: "Air Max 90 is such a vibe. The cushioning is perfect for walking around Global Village."
            },
            {
                name: "Sara Y.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Stylish and clean look. Got them as a gift and now I wear them everywhere."
            },
            {
                name: "Bilal F.",
                location: "Al Barsha, UAE",
                rating: 4.9,
                review: "First copy but seriously high-quality. Even my cousin thought they were originals."
            },
            {
                name: "Mariam S.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Wore these all day at Expo City and my feet didn’t hurt once. Big fan!"
            },
            {
                name: "Nasir D.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Air Max 90 is my go-to model. This pair just confirms it again. Love the retro design."
            }
        ]
    },
    {
        id: 10097,
        priority: 19,
        title: 'Nike Air Max 97',
        size: [40, 41, 42, 43, 44, 45],
        price: 185,
        originalPrice: 255,
        currency: 'AED',
        type: 'shoes',
        brand: 'nike',
        model: 'Air Max 97',
        colors: 4,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747407578/IMG_2738_f9jmnv.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747407583/IMG_2740_obkfod.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747407580/IMG_2736_eg1ftc.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747407580/IMG_2737_sq9uw0.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747407577/IMG_2739_azctkz.png",
        ],
        reviews: [
            {
                name: "Hassan A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The design of the Air Max 97 is unmatched. Super sleek and futuristic—love how it pops with any outfit."
            },
            {
                name: "Fatima L.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Wasn't sure about the silver color at first, but it looks stunning in real life. Walked around Yas Mall all day in comfort."
            },
            {
                name: "Omar K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Solid copy, very close to the original. The air bubble is a game changer for comfort."
            },
            {
                name: "Amina S.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "I love the sleek lines on the 97s. Got so many compliments at work and brunch."
            },
            {
                name: "Mohammed Y.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Quality is impressive for a first copy. Delivery came fast and packaging was neat."
            },
            {
                name: "Noura T.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "Great look and feel. A bit tight on the first wear but loosened up quickly."
            },
            {
                name: "Tariq B.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Air Max 97 is just iconic. The metallic gold version stands out so much!"
            },
            {
                name: "Huda R.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Really stylish. Looks premium and super comfy during shopping trips to The Galleria."
            },
            {
                name: "Yusuf D.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.9,
                review: "A little snug, but cushioning is amazing. The waves in the design are so unique."
            },
            {
                name: "Layla A.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 5,
                review: "These sneakers are everything. I paired them with wide-leg pants and it looked 🔥."
            },
            {
                name: "Salim J.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "I was surprised at how close they look to the original Nike Air Max 97. Worth every dirham!"
            },
            {
                name: "Rania H.",
                location: "Dubai Hills, UAE",
                rating: 5,
                review: "Bought it for my brother and he’s obsessed. He said it’s the most comfortable pair he owns now."
            },
            {
                name: "Ahmed M.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "I’ve always loved the ripple design on the 97s. Got the black and red colorway—pure 🔥."
            },
            {
                name: "Zahra N.",
                location: "Dubai Festival City, UAE",
                rating: 5,
                review: "Feels like I’m walking on air. The sole is bouncy and the look is modern. Definitely a keeper!"
            }
        ]
    },

    // 2 Adidas Product
    {
        id: 2001,
        title: 'Adidas Samba',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        price: 160,
        originalPrice: 200,
        currency: 'AED',
        type: 'shoes',
        brand: 'adidas',
        model: 'Samba',
        colors: 15,
        rating: 4.9,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750715/IMG_2437_z7xkjm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750732/IMG_2430_vypo01.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750731/IMG_2431_v7rwx2.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750729/IMG_2432_bxnk7w.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750729/IMG_2435_rqjnoj.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750727/IMG_2433_asxog3.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750718/IMG_2436_bujs5z.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750716/IMG_2434_y6x9zn.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750715/IMG_2437_z7xkjm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750713/IMG_2439_jedcot.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750712/IMG_2438_u5aald.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750711/IMG_2440_vg2ptg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750711/IMG_2440_vg2ptg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750710/IMG_2442_btimen.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750707/IMG_2444_tvisvp.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750706/IMG_2443_wxiqnw.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750704/IMG_2441_omrm1p.jpg",
        ],
        reviews: [
            {
                name: "Hassan R.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Samba is timeless. I’ve been wearing them with thobes and jeans—versatile and sleek!"
            },
            {
                name: "Fatima K.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Love how light they feel. Wore them to City Walk and got lots of stares—so stylish!"
            },
            {
                name: "Khaled M.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Comfort is great, especially for long days. The retro look hits differently."
            },
            {
                name: "Nour A.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "Perfect shape and design. Even though it’s a first copy, you can’t tell!"
            },
            {
                name: "Saeed Y.",
                location: "Al Ain, UAE",
                rating: 4.8,
                review: "Adidas Samba brings back the old-school vibes. Works well with casual and sporty fits."
            },
            {
                name: "Laila D.",
                location: "Ajman, UAE",
                rating: 4.9,
                review: "Good replica. Stitched well, no glue marks. Super happy with the comfort."
            },
            {
                name: "Mohammed F.",
                location: "Dubai Hills, UAE",
                rating: 5,
                review: "Classic white and black Sambas—clean and perfect for day-to-day errands or night outs."
            },
            {
                name: "Ayesha B.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "I’ve worn them non-stop since I got them. Amazing quality for a copy version."
            },
            {
                name: "Tariq S.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Fits true to size. Great arch support and feels breathable even in this heat."
            },
            {
                name: "Reem H.",
                location: "Ras Al Khaimah, UAE",
                rating: 5,
                review: "Got them with my Eid outfit and it just pulled the look together. Will buy again!"
            },
            {
                name: "Ali Z.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "The gum sole is 🔥. Really appreciate the details—feels premium."
            },
            {
                name: "Mona T.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 5,
                review: "Love pairing these with wide pants and a cropped tee. Instant cool-girl look."
            },
            {
                name: "Yousef N.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Was looking for something vintage but trendy. Adidas Samba checks all the boxes."
            },
            {
                name: "Dana A.",
                location: "Dubai Creek Harbour, UAE",
                rating: 5,
                review: "The Samba design is so clean and minimal. Looks amazing on-foot and super comfy!"
            }
        ]
    },
    {
        id: 2002,
        priority: 7,
        title: 'Adidas Campus',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44],
        price: 175,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'adidas',
        model: 'Campus',
        colors: 11,
        rating: 4.8,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314977/IMG_2602_zkivpb.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314984/IMG_2604_ajtbnq.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314981/IMG_2603_qensoi.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314988/IMG_2605_bou23e.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314964/IMG_2600_pzggg8.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314966/IMG_2599_fi8kws.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314971/IMG_2598_w8edev.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314975/IMG_2601_lutbc8.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314955/IMG_2586_wlvgql.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314957/IMG_2597_a4suqp.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747314960/IMG_2596_wsujzv.png",
        ],
        reviews: [
            {
                name: "Omar A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Adidas Campus has that classic streetwear vibe. Feels premium and looks amazing with cargo pants!"
            },
            {
                name: "Layla S.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Got the grey Campus pair—super comfy and matches most of my outfits. Delivery was smooth too."
            },
            {
                name: "Zaid M.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Been wanting Campus sneakers for a while. The replica is really well done—looks original."
            },
            {
                name: "Rania F.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "The suede finish is just perfect. Gives a soft luxury feel, especially for this price."
            },
            {
                name: "Hamad N.",
                location: "Al Ain, UAE",
                rating: 4.8,
                review: "Wore them at The Galleria—got compliments from 3 strangers. They really stand out!"
            },
            {
                name: "Amani B.",
                location: "Ajman, UAE",
                rating: 4.9,
                review: "Nice shoe, soft insole, and fits true to size. Very stylish for casual days."
            },
            {
                name: "Salem R.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love how simple yet bold the Adidas Campus design is. Goes with almost anything I wear."
            },
            {
                name: "Yasmin K.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Color is a little lighter than expected but still beautiful. Overall really happy with it."
            },
            {
                name: "Bilal D.",
                location: "Dubai Sports City, UAE",
                rating: 4.8,
                review: "Got the black ones—clean lines and iconic silhouette. Great for uni and everyday wear."
            },
            {
                name: "Mariam J.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "So comfortable I didn’t want to take them off. Honestly better than some originals I’ve owned."
            },
            {
                name: "Tamer Q.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.8,
                review: "Suede is soft and the stitching is clean. Great first-copy for the price."
            },
            {
                name: "Lina M.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 5,
                review: "Campus sneakers are underrated. Minimal and classy, just how I like it."
            }
        ]
    },

    // 3 Jordans Product
    {
        id: 3001646,
        priority: 4,
        title: 'Air Jordans 1 High Cut',
        size: [41, 42, 43, 44, 45],
        price: 175,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'jordans 1',
        colors: 10,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747851988/thumbnail_sy6vqx.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747852001/IMG_2619_twu2ac.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747852004/IMG_2618_zgwhy3.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747852004/IMG_2625_w3jm8v.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747852003/IMG_2621_nlg2h7.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747852003/IMG_2624_ylyrey.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747851998/IMG_2623_nbrjkg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747851996/IMG_2620_c1djt1.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747851995/IMG_2617_vhowwn.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747851994/IMG_2616_clf6fb.jpg",
        ],
        reviews: [
            {
                name: "Khalid A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "These Jordan 1 high are 🔥. Rocked them at City Walk and they turned heads. Super clean finish!"
            },
            {
                name: "Majid S.",
                location: "Fujairah, UAE",
                rating: 4.8,
                review: "These Jordan 1 Lows are perfect for daily wear. Got mine in white/blue—🔥🔥🔥."
            },
            {
                name: "Dana R.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Loving the silhouette. Wore them with jeans and they just elevate the whole look."
            },
            {
                name: "Rami J.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Honestly, best first copy I’ve ever purchased. Stitching and shape are exactly like the OG."
            },
            {
                name: "Samira A.",
                location: "Al Ain, UAE",
                rating: 4.8,
                review: "Super clean finish, and the comfort is better than I expected. Will get more colors!"
            },
            {
                name: "Ibrahim Q.",
                location: "Dubai Sports City, UAE",
                rating: 5,
                review: "I’ve already recommended these Jordan 1 Lows to three of my friends. Totally worth it."
            },
            {
                name: "Noura H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "The leather feels premium even though it's not the original. Very impressed with the quality."
            },
            {
                name: "Tariq Z.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Perfect fit and they look exactly like the real ones. Everyone asks me where I got them from!"
            },
            {
                name: "Sara M.",
                location: "Dubai Marina, UAE",
                rating: 4.9,
                review: "Super stylish and comfy. I wore them all day while shopping and had no foot pain."
            },
            {
                name: "Adnan Y.",
                location: "Al Ain, UAE",
                rating: 5,
                review: "First time buying the Jordan 1 high model, and wow... they are super sleek. Looks original!"
            },
            {
                name: "Zahra S.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Love the color combo and how versatile they are. Wore them with an abaya and still looked fire."
            },
            {
                name: "Omar F.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "I’ve had both original and first copy, and this one is nearly indistinguishable. 10/10."
            },
            {
                name: "Mona K.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.8,
                review: "Really lightweight and comfortable. Got them in the red and black colorway—stunning."
            },
            {
                name: "Hassan B.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.9,
                review: "Took them to school and everyone thought they were originals. Love them!"
            },
            {
                name: "Amira L.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Wore these Jordans at Dubai Mall—looked super dope. Stylish yet low-key."
            },
            {
                name: "Leila N.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Great replica. Only difference I noticed was the box packaging. Shoes themselves are on point!"
            },
            {
                name: "Yousef T.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "If you’re into sneakers but don’t want to pay resale, these are the way to go."
            },
        ]
    },
    {
        id: 3001,
        title: 'Air Jordans 1 Low',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        price: 165,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'jordans 1',
        colors: 6,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315967/IMG_2627_hwiz9j.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315763/IMG_2630_cdk98u.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315841/IMG_2626_drfxzm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315965/IMG_2631_yzwwsx.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315965/IMG_2628_lt3ntg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315846/IMG_2629_i6s6a5.jpg",
        ],
        reviews: [
            {
                name: "Khalid A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "These Jordan 1 Lows are 🔥. Rocked them at City Walk and they turned heads. Super clean finish!"
            },
            {
                name: "Noura H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "The leather feels premium even though it's not the original. Very impressed with the quality."
            },
            {
                name: "Tariq Z.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Perfect fit and they look exactly like the real ones. Everyone asks me where I got them from!"
            },
            {
                name: "Sara M.",
                location: "Dubai Marina, UAE",
                rating: 4.9,
                review: "Super stylish and comfy. I wore them all day while shopping and had no foot pain."
            },
            {
                name: "Adnan Y.",
                location: "Al Ain, UAE",
                rating: 5,
                review: "First time buying the Jordan 1 Low model, and wow... they are super sleek. Looks original!"
            },
            {
                name: "Zahra S.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Love the color combo and how versatile they are. Wore them with an abaya and still looked fire."
            },
            {
                name: "Omar F.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "I’ve had both original and first copy, and this one is nearly indistinguishable. 10/10."
            },
            {
                name: "Leila N.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Great replica. Only difference I noticed was the box packaging. Shoes themselves are on point!"
            },
            {
                name: "Yousef T.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "If you’re into sneakers but don’t want to pay resale, these are the way to go."
            },
            {
                name: "Mona K.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.8,
                review: "Really lightweight and comfortable. Got them in the red and black colorway—stunning."
            },
            {
                name: "Hassan B.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.9,
                review: "Took them to school and everyone thought they were originals. Love them!"
            },
            {
                name: "Amira L.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Wore these Jordans at Dubai Mall—looked super dope. Stylish yet low-key."
            },
            {
                name: "Majid S.",
                location: "Fujairah, UAE",
                rating: 4.8,
                review: "These Jordan 1 Lows are perfect for daily wear. Got mine in white/blue—🔥🔥🔥."
            },
            {
                name: "Dana R.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Loving the silhouette. Wore them with jeans and they just elevate the whole look."
            },
            {
                name: "Rami J.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Honestly, best first copy I’ve ever purchased. Stitching and shape are exactly like the OG."
            },
            {
                name: "Samira A.",
                location: "Al Ain, UAE",
                rating: 4.8,
                review: "Super clean finish, and the comfort is better than I expected. Will get more colors!"
            },
            {
                name: "Ibrahim Q.",
                location: "Dubai Sports City, UAE",
                rating: 5,
                review: "I’ve already recommended these Jordan 1 Lows to three of my friends. Totally worth it."
            }
        ]
    },
    {
        id: 3004,
        title: 'Air Jordans 4',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
        price: 165,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'Jordans 4',
        colors: 11,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750514/IMG_2466_a6oqwr.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750513/IMG_2467_hkltkv.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750513/IMG_2464_r1dyak.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750513/IMG_2463_rtczuq.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750513/IMG_2470_e0wauh.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750512/IMG_2472_rktqhq.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750512/IMG_2471_ouojxm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750511/IMG_2475_vhejxs.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750510/IMG_2476_rqx0er.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750510/IMG_2477_m17z4x.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750509/IMG_2478_xzugvx.jpg",
        ],
        reviews: [
            {
                name: "Omar H.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Absolutely love my Jordan 4s! The finish is clean and feels almost like the original. 🔥"
            },
            {
                name: "Fatima Z.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Super comfy and stylish! I got the black and red colorway—heads turning every time I wear them."
            },
            {
                name: "Yousef A.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Excellent build quality for a first copy. Wore them to the cinema at Mirdif City Centre—people asked where I bought them!"
            },
            {
                name: "Layla M.",
                location: "Dubai Marina, UAE",
                rating: 4.9,
                review: "Very cool design and surprisingly lightweight. Slight glue smell out of the box but went away in a day."
            },
            {
                name: "Ahmed S.",
                location: "Al Ain, UAE",
                rating: 5,
                review: "I have the OG and these side by side. Honestly, can't tell the difference unless you're a hardcore sneakerhead."
            },
            {
                name: "Zara K.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Wore them with my oversized abaya—looked edgy and modern. Quality is top-notch for the price!"
            },
            {
                name: "Bilal T.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Super solid replica. Stitching, tongue logo, and heel tab are almost exact."
            },
            {
                name: "Rana J.",
                location: "Ajman, UAE",
                rating: 4.9,
                review: "Bought them for my brother—he thought they were originals 😂 Great job!"
            },
            {
                name: "Hamza N.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "I got the white cement pair. Rocked them with jeans and they’re 🔥🔥🔥"
            },
            {
                name: "Noor A.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.8,
                review: "Just a tiny bit tight at first but after one wear, perfect. Looks super fresh!"
            },
            {
                name: "Saif R.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Took them for a photoshoot in Al Seef, and they looked amazing in every shot."
            },
            {
                name: "Mariam D.",
                location: "Ras Al Khaimah, UAE",
                rating: 4.8,
                review: "Honestly shocked how close these are to retail Jordans. Definitely buying another pair."
            },
            {
                name: "Kareem L.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "If you’re after the Jordan 4 look without the resale price—these are perfect."
            },
            {
                name: "Sami B.",
                location: "Fujairah, UAE",
                rating: 5,
                review: "Material is strong, the sole feels right, and they go with everything. Highly recommend."
            },
            {
                name: "Alya F.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Used to wear AF1s but these Jordan 4s just hit different. They feel premium!"
            },
            {
                name: "Tamer Y.",
                location: "Dubai Creek Harbour, UAE",
                rating: 5,
                review: "Got them in grey and red—just like the OGs. So comfortable and stylish."
            },
            {
                name: "Reem G.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Love the chunky vibe of the Jordan 4s. They’re bold and super trendy."
            },
            {
                name: "Waleed P.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Delivery was super fast. Got them within 2 days. Great service and amazing shoes!"
            },
            {
                name: "Lina S.",
                location: "Dubai Hills, UAE",
                rating: 4.8,
                review: "My friends thought I paid 1k+ for these—nah, got them from Luxay 😉"
            },
            {
                name: "Jamal M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Can’t believe how original these look. Jordan 4s have never been more affordable!"
            }
        ]
    },
    {
        id: 3006,
        priority: 8,
        title: 'Air Jordans 6 Retro',
        size: [40, 41, 42, 43, 44, 45],
        price: 210,
        originalPrice: 270,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'Jordans 6',
        colors: 10,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403180/IMG-20231002-WA0103f_yjmjuf.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403194/WhatsAppImage2023-11-08at5.36.29PM_wtwdsx.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403192/vsf_xzvui9.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403192/IMG_2729_zyfj8z.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403191/IMG_2722_tl5xfu.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403186/jordan-air-6-retro-gssd_s4diz8.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403184/IMG_2726_bmbnnl.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403183/IMG_2724_m0mozg.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403179/fsvsvfs_teyfqo.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403178/dsdsfdwefe_rcxpry.jpg",
        ],
        reviews: [
            {
                name: "Zayed K.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Jordan 6 Retro looks amazing! Great comfort and very stylish for daily wear."
            },
            {
                name: "Maya R.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Perfect fit and the colorway is just like the originals. Everyone at the mall loved them!"
            },
            {
                name: "Fahad N.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good value for money. Slightly different stitching but overall very close to the real thing."
            },
            {
                name: "Sara A.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "Wore these all day at the beach walk, no discomfort at all. Jordan 6 Retro is my new favorite."
            },
            {
                name: "Omar T.",
                location: "Ajman, UAE",
                rating: 5,
                review: "Amazing detail and quality for a replica. Got lots of compliments from sneakerheads."
            },
            {
                name: "Noura H.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Good sneakers but the sole feels a bit harder than my original pair."
            },
            {
                name: "Hassan J.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Jordan 6 Retro fits perfectly and the material feels premium. Love it!"
            },
            {
                name: "Fatima S.",
                location: "Al Ain, UAE",
                rating: 4.8,
                review: "Stylish and comfortable. Took them out for a walk around the city, and they held up well."
            },
            {
                name: "Khalid M.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Look just like the originals! Friends asked where I got them from, and I recommended Luxay."
            },
            {
                name: "Lama D.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.9,
                review: "The Jordan 6 Retro is a bit narrow, but the design is on point."
            },
            {
                name: "Yusuf A.",
                location: "Fujairah, UAE",
                rating: 5,
                review: "Very comfortable sneakers for everyday use. Great replica for the price."
            },
            {
                name: "Rania K.",
                location: "Dubai Hills, UAE",
                rating: 4.8,
                review: "The color and stitching are great. No complaints after wearing them for a week."
            },
            {
                name: "Abdullah F.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Got these for my brother, and he loves the look and feel. Would buy again!"
            },
            {
                name: "Mona Z.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good quality for a replica but the tongue logo could be a bit sharper."
            },
            {
                name: "Saeed R.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Superb craftsmanship! These Jordan 6 Retro look and feel amazing."
            },
            {
                name: "Noor T.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "I love the classic design of these Jordans. Perfect for casual and semi-formal looks."
            }
        ]
    },
    {
        id: 3009,
        priority: 5,
        title: 'Air Jordans 9',
        size: [40, 41, 42, 43, 44, 45],
        price: 230,
        originalPrice: 300,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'Jordans 9',
        colors: 8,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401855/IMG_2714_uy2xiw.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401852/IMG_2718_qicpey.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401855/IMG_2720_rl4xut.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401850/IMG_2715_a4dls7.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401849/IMG_2712_b3ohwx.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401848/IMG_2713_mlgiox.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401846/fdfds_ykmrsw.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401846/erfer_oeu60k.jpg",
        ],
        reviews: [
            {
                name: "Ahmed S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Air Jordans 9 are super comfy and stylish. Perfect for daily wear around Dubai."
            },
            {
                name: "Laila M.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Love the sleek design of these Jordans. Got so many compliments at the mall."
            },
            {
                name: "Faris K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Great replica for the price. The build quality is impressive."
            },
            {
                name: "Salma H.",
                location: "Dubai Marina, UAE",
                rating: 5,
                review: "Air Jordans 9 fit perfectly and are very comfortable even after hours of walking."
            },
            {
                name: "Mohammed A.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Very happy with the Jordan 9 replica. The details are well done."
            },
            {
                name: "Nada R.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "Good quality but the colors are a bit different from the original."
            },
            {
                name: "Omar N.",
                location: "Dubai, UAE",
                rating: 5,
                review: "These Jordan 9s are my favorite sneakers now. Stylish and durable."
            },
            {
                name: "Huda T.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Comfortable and good for casual outings. Worth the price."
            },
            {
                name: "Khaled F.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Got the Jordan 9 for my son. He loves them and wears them every day."
            },
            {
                name: "Mariam Z.",
                location: "Dubai Silicon Oasis, UAE",
                rating: 4.9,
                review: "Nice replica but the sole feels a bit stiff at first."
            },
            {
                name: "Yousef D.",
                location: "Fujairah, UAE",
                rating: 5,
                review: "Great look and feel. I wear them to the gym and around the city."
            },
            {
                name: "Rana K.",
                location: "Dubai Hills, UAE",
                rating: 4.8,
                review: "Air Jordans 9 have a clean design. Comfortable and stylish."
            },
            {
                name: "Saif E.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Perfect fit and excellent quality. I highly recommend these Jordans."
            },
            {
                name: "Noor S.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Very close to the original design, but some stitching could be improved."
            },
            {
                name: "Ibrahim H.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Love these Jordan 9s! Stylish, comfy, and great for everyday use."
            }
        ]
    },
    {
        id: 30011,
        priority: 20,
        title: 'Air Jordans 11',
        size: [40, 41, 42, 43, 44, 45],
        price: 209,
        originalPrice: 270,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'Jordans 11',
        colors: 10,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423071/IMG_2679_aojohs.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423066/IMG_2670_aemkxw.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423069/IMG_2677_o0ba3v.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423069/IMG_2678_kyalsk.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423069/IMG_2676_toywmk.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423067/IMG_2675_zas84r.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423066/IMG_2673_joblfi.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423066/IMG_2672_nbagne.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423066/IMG_2674_b8m5si.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747423066/IMG_2671_xciypr.png",
        ],
        reviews: [
            {
                name: "Zainab A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Air Jordans 11 are my favorite sneakers. Very comfortable and look amazing on the streets of Dubai."
            },
            {
                name: "Hassan M.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Great quality replica. The shine on the Jordans 11 is perfect and the fit is just right."
            },
            {
                name: "Sara K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Comfortable and stylish, but the sole could be a bit softer."
            },
            {
                name: "Fahad N.",
                location: "Ajman, UAE",
                rating: 5,
                review: "Love the design and comfort of the Jordans 11. Got lots of compliments when I wore them to the mall."
            },
            {
                name: "Amira S.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Very close to original Jordans, good for casual and semi-formal wear."
            },
            {
                name: "Khalid T.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "Good value for money. Slightly heavier than expected but still great sneakers."
            },
            {
                name: "Nora H.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Stylish and comfortable. Perfect for long walks around the city."
            },
            {
                name: "Omar W.",
                location: "Dubai Marina, UAE",
                rating: 4.8,
                review: "The classic look of Jordans 11 is unmatched. Replica is very well made."
            },
            {
                name: "Layla F.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "I wear my Jordans 11 daily. Great for both sporty and casual looks."
            },
            {
                name: "Mohammed J.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "The sneakers are good but the stitching could be a bit neater."
            },
            {
                name: "Huda R.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Very happy with my purchase. The Jordans 11 replica feels premium."
            },
            {
                name: "Saeed A.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Comfortable sneakers and perfect for everyday wear."
            },
            {
                name: "Maha B.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love the patent leather shine and the overall style of Jordans 11."
            }
        ]
    },
    {
        id: 30012,
        priority: 10,
        title: 'Air Jordans 12',
        size: [40, 41, 42, 43, 44, 45],
        price: 239,
        originalPrice: 310,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'Jordans 12',
        colors: 8,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401000/IMG_2680_wwwret.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747400999/ebhtt_colvwj.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401003/m_6114494d800f642534ed5b70_qlekn5.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401001/IMG_2685_qpkt8l.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401002/IMG_2684_keivgg.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747400998/481291826_613461704869014_4061045540006943282_n_i3mkod.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401003/IMG_2690_yg9e85.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401010/IMG_2681_qdcr6z.png",
        ],
        reviews: [
            {
                name: "Amina S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Air Jordans 12 look fantastic and are very comfortable. Perfect for daily wear in Dubai."
            },
            {
                name: "Rashid K.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Great replica with good attention to detail. The quality is impressive for the price."
            },
            {
                name: "Laila M.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Stylish sneakers but felt a bit tight initially. Now they fit just right."
            },
            {
                name: "Omar F.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love the color and design. The Air Jordans 12 are perfect for casual outings."
            },
            {
                name: "Zainab H.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Comfortable and trendy. Received many compliments wearing these Jordans."
            },
            {
                name: "Khalil N.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "Good quality but the soles wear out faster than expected."
            },
            {
                name: "Maryam J.",
                location: "Dubai, UAE",
                rating: 5,
                review: "I’m very satisfied with my Air Jordans 12. They look very close to the original."
            },
            {
                name: "Saeed R.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Good fit and stylish design. Great for streetwear fashion."
            },
            {
                name: "Fatima W.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "These Jordans 12 are super comfortable and the stitching is well done."
            },
            {
                name: "Hassan T.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Nice sneakers but slightly heavier than I expected."
            },
            {
                name: "Amal S.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Perfect for both sports and casual wear. Love my Air Jordans 12!"
            },
            {
                name: "Yousef K.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Very comfortable and durable. Would definitely buy again."
            },
            {
                name: "Noor A.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Stylish and true to size. The best Jordans I have owned so far."
            },
            {
                name: "Ali M.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good quality replica, but the tongue could be more padded."
            },
            {
                name: "Salma F.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "I wear my Air Jordans 12 almost every day. Very comfortable and stylish."
            },
            {
                name: "Tariq H.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Love the design and fit. Great sneakers for the price."
            },
            {
                name: "Maya N.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Best Jordans for casual wear. Looks amazing and feels comfortable."
            }
        ]
    },
    {
        id: 30013,
        priority: 11,
        title: 'Air Jordans 13',
        size: [40, 41, 42, 43, 44, 45],
        price: 250,
        originalPrice: 320,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'Jordans 13',
        colors: 10,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402600/54568396db1e4fb4bfe8a75318364c31_yy7ocp.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402612/IMG_2707_b3fmoz.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402609/IMG_2703_evedjh.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402606/IMG_2702_ir9nue.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402599/fvf_f_mts7ev.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402603/IMG_2705_mjbecm.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402601/evevde_shk13e.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402610/IMG_2704_e7vtru.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402612/IMG_2709_fn5jc3.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747402670/IMG_2711_cadskf.png",
        ],
        reviews: [
            {
                name: "Samiya A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Air Jordans 13 have an amazing look and are really comfortable for daily wear."
            },
            {
                name: "Khalid B.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Great quality and style. The shoes fit perfectly and feel sturdy."
            },
            {
                name: "Rania M.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Very stylish but took a bit of time to break in. Worth it though."
            },
            {
                name: "Faisal N.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love the classic design of the Air Jordans 13. Comfortable for sports and casual wear."
            },
            {
                name: "Noor H.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Good replicas with nice attention to detail. Received lots of compliments."
            },
            {
                name: "Hassan K.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "The cushioning is decent, but the shoes feel a bit heavy."
            },
            {
                name: "Layla S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Very happy with these Jordans. They look authentic and feel comfortable."
            },
            {
                name: "Omar F.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Perfect fit and stylish design. Would recommend to any sneakerhead."
            },
            {
                name: "Maryam A.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Air Jordans 13 are a great addition to my collection. Comfortable and trendy."
            },
            {
                name: "Zayed T.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good quality shoes but expected better breathability."
            },
            {
                name: "Fatima N.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "The design and comfort are top-notch. Very pleased with my purchase."
            },
            {
                name: "Sultan M.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Stylish and solid sneakers. Perfect for everyday wear and sports."
            }
        ]
    },
    {
        id: 30014,
        priority: 12,
        title: 'Air Jordans 14',
        size: [40, 41, 42, 43, 44, 45],
        price: 279,
        originalPrice: 350,
        currency: 'AED',
        type: 'shoes',
        brand: 'jordans',
        model: 'Jordans 14',
        colors: 5,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401464/rtbgrt_ybrnsy.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401464/IMG_2693_xmiw8r.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401464/IMG_2695_ndgheh.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401465/s-l1600vfsdf_bkpcfg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747401461/3d263edb9fb248fc821be09045e633e3fd_avpv1z.jpg",
        ],
        reviews: [
            {
                name: "Noura S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Air Jordans 14 are super stylish and very comfortable. Great for casual wear."
            },
            {
                name: "Adil H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Really love the sleek design. The fit is perfect and the quality feels premium."
            },
            {
                name: "Layla R.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good sneakers overall. Took a little time to get used to, but worth it."
            },
            {
                name: "Omar F.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Air Jordans 14 have a unique look and great cushioning. Highly recommend."
            },
            {
                name: "Fatima K.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "Very comfortable for long wear, and I get compliments every time I wear them."
            },
            {
                name: "Mohammed Z.",
                location: "Al Ain, UAE",
                rating: 4.9,
                review: "Solid build and nice materials. The design really stands out in the crowd."
            },
            {
                name: "Sara M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Best sneakers I’ve owned in a while. Stylish and comfortable for daily use."
            },
            {
                name: "Yusuf T.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Perfect fit and very durable. The Air Jordans 14 are worth the investment."
            },
            {
                name: "Mariam H.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Love the design and the comfort level is excellent. Great for both sports and casual."
            },
            {
                name: "Saeed A.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good sneakers, but I wish they were a bit lighter. Still very stylish."
            },
            {
                name: "Aisha N.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "The Air Jordans 14 are amazing! Comfortable, stylish, and good quality."
            },
            {
                name: "Hassan M.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Nice design and solid comfort. Received many compliments wearing these."
            },
            {
                name: "Noor J.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good quality but a bit bulky. Perfect for casual outings though."
            },
            {
                name: "Rashid Q.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love these Jordans! Stylish and super comfy for everyday wear."
            }
        ]
    },

    // 4 LV Product
    {
        id: 4001,
        priority: 2,
        title: 'LV Trainer Sneakers',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        price: 195,
        originalPrice: 255,
        currency: 'AED',
        type: 'shoes',
        brand: 'lv',
        model: 'Trainer Sneakers',
        colors: 9,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750743/IMG_2456_wk2ubl.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750745/IMG_2452_u2xgis.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750747/IMG_2448_btqadu.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750748/IMG_2450_x8y16f.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750746/IMG_2449_sjqi0f.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750750/dss_xcovif.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750751/zdfdf_dale4w.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750752/ds_vzwera.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750754/Artboard_1-100_rbqrka.jpg",
        ],
        reviews: [
            {
                name: "Laila A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Absolutely love my LV Trainer Sneakers! The quality and style are unmatched."
            },
            {
                name: "Faisal M.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Very comfortable and classy sneakers. Perfect for both casual and semi-formal occasions."
            },
            {
                name: "Noor S.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "The LV Trainers are so stylish! Got plenty of compliments when I wore them to the mall."
            },
            {
                name: "Omar R.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good quality shoes, but a bit pricey. Still worth it for the luxury feel."
            },
            {
                name: "Mariam K.",
                location: "Ajman, UAE",
                rating: 4.8,
                review: "The LV Trainer Sneakers have excellent cushioning and a sleek design. Highly recommend."
            },
            {
                name: "Saeed Y.",
                location: "Dubai, UAE",
                rating: 5,
                review: "These sneakers are my favorite! Stylish, comfortable, and well made."
            },
            {
                name: "Fatima N.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Really love the design but took a little time to break in. Now super comfy."
            },
            {
                name: "Hassan B.",
                location: "Dubai, UAE",
                rating: 5,
                review: "LV Trainer Sneakers are a perfect blend of luxury and comfort. Worth every dirham."
            },
            {
                name: "Aisha D.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Elegant and comfortable sneakers. I wear mine almost every day."
            },
            {
                name: "Yusuf F.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good build quality but a bit heavy. Still love the style and brand prestige."
            },
            {
                name: "Nadia H.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "The LV Trainers exceeded my expectations! Stylish and very durable."
            },
            {
                name: "Khalid S.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Comfortable and trendy sneakers. I get compliments every time I wear them."
            },
            {
                name: "Rania J.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Lovely design but sizing runs a bit small. Recommend going a half size up."
            },
            {
                name: "Ibrahim T.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Really love these LV Trainer Sneakers. The leather is soft and premium."
            },
            {
                name: "Samar A.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Stylish and comfortable sneakers for everyday wear. Definitely a luxury piece."
            },
            {
                name: "Zainab M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "These LV Trainers are perfect for my style. Very comfortable and classy."
            },
            {
                name: "Omar K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good quality but a bit expensive. Still happy with my purchase."
            },
            {
                name: "Maryam Q.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love my LV Trainer Sneakers! The design and comfort are top-notch."
            },
            {
                name: "Fahad L.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Very stylish sneakers and comfortable. Ideal for casual outings in UAE."
            },
            {
                name: "Salma R.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The LV Trainer Sneakers are elegant and very durable. Highly recommend for sneaker lovers."
            }
        ]
    },

    // 5 New Balance Product
    {
        id: 5001,
        priority: 9,
        title: 'New Balance 530',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        price: 179,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'new balance',
        model: '530',
        colors: 5,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315530/IMG_2551_bcck7p.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315561/IMG_2572_qb5d4f.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315532/IMG_2571jj_pxwmgz.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315576/IMG_2570_qlu7cd.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747315579/IMG_2573_w5tv8h.jpg",
        ],
        reviews: [
            {
                name: "Ahmed S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "New Balance 530 feels amazing on my feet. Perfect for walking around the city."
            },
            {
                name: "Sara K.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Comfortable and stylish sneakers. Love wearing my NB 530 to the mall."
            },
            {
                name: "Yousef M.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good cushioning and support, though a bit narrow for my feet."
            },
            {
                name: "Fatima R.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The New Balance 530 shoes are perfect for daily wear and very trendy."
            },
            {
                name: "Mohammed A.",
                location: "Ajman, UAE",
                rating: 4.9,
                review: "Nice sneakers but the color faded a bit after a month of use."
            },
            {
                name: "Noor H.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Love the retro look of the NB 530. Very comfortable for long hours."
            },
            {
                name: "Khalid J.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Good quality sneakers with solid grip. Ideal for UAE weather."
            },
            {
                name: "Lama W.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Fits well but took some time to break in. Now very comfy."
            },
            {
                name: "Omar N.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The New Balance 530 is a reliable shoe with great design and comfort."
            },
            {
                name: "Maha F.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Stylish and light sneakers. Perfect for my morning runs."
            },
            {
                name: "Hassan T.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Durable but a little heavy. Good for casual and sports use."
            },
            {
                name: "Salma Z.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Really love my New Balance 530! Great value for money."
            },
            {
                name: "Faisal M.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Comfortable sneakers with a great fit. Would buy again."
            },
            {
                name: "Aisha L.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Perfect blend of style and comfort. Highly recommended."
            },
            {
                name: "Rashid K.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good shoe for everyday wear but could use better arch support."
            },
            {
                name: "Dina S.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Love the cushioning in these New Balance 530 sneakers."
            },
            {
                name: "Ibrahim Y.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Great sneakers with solid construction. Perfect for UAE lifestyle."
            }
        ]
    },
    {
        id: 5002,
        priority: 6,
        title: 'New Balance 9060',
        size: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
        price: 205,
        originalPrice: 270,
        currency: 'AED',
        type: 'shoes',
        brand: 'new balance',
        model: '9060',
        colors: 15,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2496_ccv7px.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750486/IMG_2500_f4v2ym.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750486/IMG_2490_vckqpi.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750486/IMG_2497_zh7p1l.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750486/IMG_2501_ougw2x.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750486/IMG_2498_gsde9u.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750485/IMG_2482_pciq8t.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2499_hikgzg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2491_g9rtuz.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2493_r9y8ky.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2495_afdgic.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750488/IMG_2481_ds9qsm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2486_ves8mi.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2485_nhfsmr.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1746750487/IMG_2483_qmy0qr.jpg",
        ],
        reviews: [
            {
                name: "Sara N.",
                location: "Dubai, UAE",
                rating: 5,
                review: "New Balance 9060 is very stylish and super comfy. Perfect for daily wear."
            },
            {
                name: "Mohammed H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Great shoe with excellent cushioning. Feels very supportive on my feet."
            },
            {
                name: "Fatima K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Love the look of NB 9060 but took some time to get used to the fit."
            },
            {
                name: "Omar S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Really comfortable sneakers, ideal for walking around Dubai all day."
            },
            {
                name: "Layla M.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Good quality shoe but the sizing runs a little small, order one size up."
            },
            {
                name: "Yousef R.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Perfect balance between style and comfort, great for casual wear."
            },
            {
                name: "Huda T.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "The New Balance 9060 looks great and the sole is very cushy."
            },
            {
                name: "Khalid A.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good shoe for everyday use, though it feels a bit heavy at first."
            },
            {
                name: "Noura J.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Comfortable fit and great for UAE's warm weather. Love the design too!"
            },
            {
                name: "Saeed M.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "High quality and durable sneakers. New Balance 9060 is worth the price."
            },
            {
                name: "Aisha F.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Very stylish but I wish the color options were more vibrant."
            },
            {
                name: "Rashid E.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Lightweight and comfortable, perfect for all-day wear around the city."
            },
            {
                name: "Mariam L.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Great support and cushioning. I get compliments every time I wear them."
            },
            {
                name: "Faisal Q.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Solid sneakers but could be a bit more breathable for hot days."
            }
        ]
    },

    // 6 Puma
    {
        id: 6001,
        title: 'Puma Sky LX Low',
        size: [40, 41, 42, 43, 44],
        price: 160,
        originalPrice: 250,
        currency: 'AED',
        type: 'shoes',
        brand: 'puma',
        model: 'Sky LX Low',
        colors: 4,
        rating: 5,
        subTitle: "Men's Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747400233/IMG_2659_dheth5.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747400233/IMG_2660_dcctsm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747400233/IMG_2657_b4ez9d.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747400235/IMG_2658_pg931z.jpg",
        ],
        reviews: [
            {
                name: "Ahmed B.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Puma Sky LX Low is very comfortable and stylish. Perfect for everyday wear."
            },
            {
                name: "Fatima S.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Love the design and cushioning of these Puma sneakers. Got many compliments!"
            },
            {
                name: "Hassan K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good quality shoe but the fit felt a bit snug initially."
            },
            {
                name: "Layla M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Really happy with Puma Sky LX Low, feels light and breathable in the UAE heat."
            },
            {
                name: "Mohammed R.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Stylish shoe but the sole could be softer for better comfort."
            },
            {
                name: "Sara A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Excellent sneakers! The Puma Sky LX Low fits perfectly and looks great."
            },
            {
                name: "Omar N.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Durable and trendy. Perfect for casual outings in the city."
            },
            {
                name: "Reem J.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Nice color options but I wish they had more sizes available."
            },
            {
                name: "Khalid Y.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Puma always delivers quality. The Sky LX Low did not disappoint."
            },
            {
                name: "Noura H.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Comfortable but not very breathable, can get warm after long wear."
            },
            {
                name: "Saeed M.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Great support and stylish design, fits well with my casual outfits."
            },
            {
                name: "Mariam F.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Perfect for walking around Dubai Mall all day. Very comfortable!"
            },
            {
                name: "Yousef A.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Good quality but took a few days to break them in."
            },
            {
                name: "Huda S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "I love the Puma Sky LX Low! They look sleek and feel great on my feet."
            },
            {
                name: "Rashid T.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Nice shoe but the laces could be better quality."
            },
            {
                name: "Aisha Z.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Lightweight and stylish – perfect for the UAE lifestyle."
            },
            {
                name: "Faisal N.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Very happy with my Puma Sky LX Low, would definitely recommend."
            }
        ]
    },

    // 7 Hoka
    {
        id: 7001,
        priority: 15,
        title: 'HOKA Skyline-Float X',
        size: [40, 41, 42, 43, 44],
        price: 295,
        originalPrice: 370,
        currency: 'AED',
        type: 'shoes',
        brand: 'hoka',
        model: 'Skyline-Float X',
        colors: 4,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403405/IMG_2732_mzxwag.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403462/IMG_2733_oaakj0.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403463/IMG_2734_xykqoc.png",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747403464/IMG_2735_ndfpy4.png",
        ],
        reviews: [
            {
                name: "Salim A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "HOKA Skyline-Float X feels like walking on clouds! Perfect for long walks in the city."
            },
            {
                name: "Noor F.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Super comfy and lightweight. Great for jogging around the Corniche."
            },
            {
                name: "Omar K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Nice cushioning but took some time to get used to the sole’s height."
            },
            {
                name: "Layla M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love the support and style of the HOKA Skyline-Float X. Ideal for UAE heat."
            },
            {
                name: "Faisal J.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Great shoe overall but wished it was a bit more breathable."
            },
            {
                name: "Mariam H.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Perfect for my daily runs and casual wear. HOKA never disappoints!"
            },
            {
                name: "Ahmed N.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Really impressed by the comfort and durability of these sneakers."
            },
            {
                name: "Sara D.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good fit but I had to size up for extra comfort."
            },
            {
                name: "Khalid R.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Excellent cushioning and stylish design. I recommend HOKA Skyline-Float X."
            },
            {
                name: "Noura B.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Comfortable but a bit heavy compared to other running shoes."
            },
            {
                name: "Saeed M.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Great for long distance walks and daily wear in the city."
            },
            {
                name: "Reem A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love the balance between style and comfort. Perfect for UAE lifestyle."
            },
            {
                name: "Yousef T.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Good support but wish the color options were better."
            },
            {
                name: "Huda F.",
                location: "Dubai, UAE",
                rating: 5,
                review: "My go-to shoe for running and casual outings. HOKA Skyline-Float X rocks!"
            },
            {
                name: "Rashid Z.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good durability but a bit pricey for everyday wear."
            },
            {
                name: "Aisha K.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Lightweight, comfy, and great for UAE’s hot weather."
            }
        ]
    },

    // 8 Loewe x On Cloudtilt 
    {
        id: 8001,
        priority: 13,
        title: 'Loewe x On Cloudtilt Sneakers',
        size: [36, 37, 38, 49, 40, 41],
        price: 199,
        originalPrice: 270,
        currency: 'AED',
        type: 'shoes',
        brand: 'loewe',
        model: 'Loewe x On Cloudtilt',
        colors: 10,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419994/IMG_2575_mgcrz7.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419995/IMG_25745_wgsvpk.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419996/IMG_2578_idghsw.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419998/IMG_2579_w7nlc8.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419997/IMG_2581_eynwpy.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747420000/IMG_2580_qybi7b.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747420000/IMG_2583_eo9d5q.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747420000/IMG_2582_bdwwxx.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747420001/IMG_2584_q8vv6z.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747419996/IMG_2577_ii5ruf.jpg",
        ],
        reviews: [
            {
                name: "Fatima S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Loewe x On Cloudtilt Sneakers are a perfect blend of luxury and comfort. I wear them everywhere in Dubai!"
            },
            {
                name: "Mohammed H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Super stylish and very comfortable. These sneakers definitely stand out in the UAE crowd."
            },
            {
                name: "Noor A.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Love the unique design and light feel. Perfect for city walks and casual outings."
            },
            {
                name: "Yousef M.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Great sneaker but a bit pricey. Quality matches the Loewe name though."
            },
            {
                name: "Layla R.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "These Loewe x On Cloudtilt sneakers give me all the compliments! So comfortable and chic."
            },
            {
                name: "Omar F.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Very lightweight and perfect for the UAE heat. Wear them daily."
            },
            {
                name: "Sara K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Comfortable but took a little time to break in. Great quality overall."
            },
            {
                name: "Khalid B.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Loewe x On Cloudtilt is the best sneaker collaboration I've tried this year!"
            },
            {
                name: "Mariam D.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Good support and cushion but wish there were more color options."
            },
            {
                name: "Rashid A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "I love the style and the comfort level. Great for everyday use in UAE."
            },
            {
                name: "Noura T.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Quality matches the brand's reputation. Very happy with this purchase."
            },
            {
                name: "Faisal M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Perfect for both sports and casual wear. Highly recommend Loewe x On Cloudtilt!"
            },
            {
                name: "Huda N.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Nice design but a bit on the heavier side compared to other sneakers."
            },
            {
                name: "Saeed Y.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Extremely comfortable and stylish. My favorite pair for the UAE weather."
            },
            {
                name: "Reem Z.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Loewe and On did an amazing job. These sneakers are both trendy and functional."
            },
            {
                name: "Ahmed Q.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Good cushioning and support but a little pricey for my budget."
            },
            {
                name: "Salma W.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Super comfy for long walks and look great with everything!"
            },
            {
                name: "Nabil K.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Great fit and very durable. Perfect for daily wear."
            },
            {
                name: "Aisha J.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Lightweight, stylish, and perfect for the UAE lifestyle."
            },
            {
                name: "Ibrahim L.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Love these sneakers! They combine Loewe’s luxury with On’s comfort perfectly."
            },
            {
                name: "Dana S.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Comfortable but I wish they had more vibrant colors available."
            },
            {
                name: "Faris M.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The best sneakers I've owned for casual and sport use in the UAE."
            },
            {
                name: "Lina A.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "Good quality and looks very premium. I get a lot of compliments."
            },
            {
                name: "Othman R.",
                location: "Dubai, UAE",
                rating: 5,
                review: "These sneakers are a perfect balance of comfort and luxury."
            },
            {
                name: "Hanan F.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Comfortable but a bit expensive. Worth it if you love Loewe’s style."
            }
        ]
    },

    // 9 Yeezy
    {
        id: 9001,
        priority: 14,
        title: 'Yeezy 350',
        size: [36, 37, 38, 49, 40, 41, 42, 43, 44, 45],
        price: 149,
        originalPrice: 220,
        currency: 'AED',
        type: 'shoes',
        brand: 'yeezy',
        model: '350',
        colors: 10,
        rating: 5,
        subTitle: "Unisex Shoes",
        category: 'Lifestyle',
        description: "",
        image: '/images/IMG_2513.jpg',
        images: [
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515901/IMG_2783_lsd7ro.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515901/IMG_2784_lwehgh.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515901/IMG_2781_ovf6iv.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515900/IMG_2782_z8fcwr.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515899/IMG_2779_imlvu9.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515899/IMG_2780_pwhghy.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515899/IMG_2776_p2ziyq.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515899/IMG_2778_veqczm.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515898/IMG_2777_loudhg.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515898/IMG_2775_eehzir.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747515897/IMG_2774_e8zbqk.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747612732/IMG_2773_arhwfy.jpg",
            "https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1747612733/IMG_2772_ig0amr.jpg",
        ],
        reviews: [
            {
                name: "Ahmed S.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Yeezy 350 sneakers are super comfortable and stylish. Perfect for daily wear in the UAE heat."
            },
            {
                name: "Fatima N.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Love the unique design and the lightweight feel. Got many compliments around Dubai."
            },
            {
                name: "Mohammed K.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Good quality, but I wish they were a bit more breathable for the hot weather."
            },
            {
                name: "Layla A.",
                location: "Dubai, UAE",
                rating: 5,
                review: "The Yeezy 350 is my go-to sneaker for casual outings and even some light sports."
            },
            {
                name: "Omar H.",
                location: "Abu Dhabi, UAE",
                rating: 4.8,
                review: "Very comfortable and stylish. The cushioning is great for walking around the city."
            },
            {
                name: "Sara M.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Nice sneaker overall but runs a bit small. Recommend trying before buying."
            },
            {
                name: "Khalid T.",
                location: "Sharjah, UAE",
                rating: 5,
                review: "Yeezy 350s are iconic! I wear mine everywhere in UAE and they hold up well."
            },
            {
                name: "Mariam F.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Comfortable but the color options are limited for my taste."
            },
            {
                name: "Yousef D.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Great sneaker for both style and comfort. Perfect for Dubai’s urban lifestyle."
            },
            {
                name: "Noura R.",
                location: "Dubai, UAE",
                rating: 4.8,
                review: "Love the Yeezy brand and this model does not disappoint. Very lightweight."
            },
            {
                name: "Faisal J.",
                location: "Sharjah, UAE",
                rating: 4.9,
                review: "Decent sneaker, but I expected more cushioning for the price."
            },
            {
                name: "Reem K.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Yeezy 350s are stylish and very comfortable. I use them daily for work and leisure."
            },
            {
                name: "Hassan B.",
                location: "Abu Dhabi, UAE",
                rating: 4.9,
                review: "Good fit and quality. Wish they were a bit more affordable here in UAE."
            },
            {
                name: "Salma W.",
                location: "Dubai, UAE",
                rating: 5,
                review: "Superb design and very comfy. Love showing them off in the UAE streets!"
            },
            {
                name: "Nabil A.",
                location: "Sharjah, UAE",
                rating: 4.8,
                review: "The sneakers feel premium and are great for long walks or casual wear."
            },
            {
                name: "Aisha T.",
                location: "Dubai, UAE",
                rating: 4.9,
                review: "Lightweight and breathable, but I wish the soles were more durable."
            },
            {
                name: "Ibrahim M.",
                location: "Abu Dhabi, UAE",
                rating: 5,
                review: "Yeezy 350 is hands down one of the best sneakers for comfort and style!"
            }
        ]
    },
];

// Helper functions to filter products
export const getProductsByBrand = (brand) => {
    return AllProducts.filter(product => product.brand.toLowerCase() === brand.toLowerCase());
};

export const getProductById = (id) => {
    return AllProducts.find(product => product.id === id);
};

AllProducts.sort((a, b) => {
    // Handle undefined priorities (push to end)
    if (a.priority === undefined) return 1;
    if (b.priority === undefined) return -1;
    return a.priority - b.priority;
});

export { AllProducts };

export const NikeProducts = getProductsByBrand('nike');
export const JordansProducts = getProductsByBrand('jordans');
export const AdidasProducts = getProductsByBrand('adidas');
export const NewBalanceProducts = getProductsByBrand('new balance');
export const LVProducts = getProductsByBrand('lv');